import React from "react";
import { HashLink as Link } from "react-router-hash-link";

const Footer = () => (
  <footer className="footer">
    <div className="footer__content">
      <ul className="footer__content--usefulLinks">
        <h3 className="footer__content--usefulLinksTitle">Liens utiles</h3>
        <li>
          <Link to="/#aboutUs" className="footer__content--usefulLink">
            À propos
          </Link>
        </li>
        <li>
          <Link to="/#hiwb" className="footer__content--usefulLink">
            Comment ça marche
          </Link>
        </li>
        <li>
          <Link to="/#contactUs" className="footer__content--usefulLink">
            Contact
          </Link>
        </li>
      </ul>
      <div className="footer__content--stores">
        <h3 className="footer__content--storesTitle">
          Applis gratuites pour votre clientèle
        </h3>
        <a
          href="https://play.google.com/store/apps/details?id=com.carte_verte"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="googlePlay"
            alt="GooglePlay"
            src="/images/googlePlay.svg"
          />
        </a>
        <a
          href="https://apps.apple.com/fr/app/carte-verte/id1633764956"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="appStore" alt="AppStore" src="/images/appStore.svg" />
        </a>
      </div>
      <ul className="footer__content--socialMedia">
        <li>
          <a href="#">
            <i className="ion-social-facebook"></i>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="ion-social-twitter"></i>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="ion-social-youtube"></i>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="ion-social-instagram"></i>
          </a>
        </li>
      </ul>
    </div>
    <div className="footer__legalPages">
      <div className="footer__legalPages--copyright">
        &copy; <span style={{ color: "white" }}>Carte Verte</span>, 2022 - Tous
        droits réservés
      </div>
      <div className="footer__legalPages--rights">
        <Link to="/mentions-legales#" className="footer__legalPages--right">
          Mentions Légales
        </Link>
        <Link
          to="/mentions-legales#dataPrivacy"
          className="footer__legalPages--right"
        >
          Protection des données
        </Link>
        <Link to="/cgu#root" className="footer__legalPages--right">
          CGU
        </Link>
      </div>
      <Link className="logo logoFooter" to="/#">
        <img src="/images/logo.png" alt=""></img>
      </Link>
    </div>
  </footer>
);

export default Footer;
